export default __webpack_public_path__ + "static/media/chaise-rounded-rectangle-2-breaks.3635909e.webp";